import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { ReactElement } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { convertTime } from '../../../../common/utils/utils';
import { useGetLiveResultMutation } from '../../../../services/api/apiProvider';
import { ResponseLiveResult } from '../../../../services/api/models/response/responseLiveResult';
import { LiveProps } from '../../LiveContainer';
import PuffLoader from 'react-spinners/PuffLoader';
import './LiveResult.scss';
import { reproio } from '../../../../common/utils/reproio';
import { APP_BASE_URL } from '../../../../loadEnv';

export const LiveResult = (props: LiveProps): ReactElement => {
  const [getLiveResult] = useGetLiveResultMutation();
  const [liveResult, setLiveResult] = useState<
    ResponseLiveResult | undefined
  >();

  const onClickEndLive = () => {
    // end live
    window.location.href = `${window.location.origin}/${APP_BASE_URL}`;
  };

  useEffect(() => {
    if (props.liveState.isEnded && liveResult) {
      reproio('track', 'screen finish broadcast', {
        kind: props.liveState.isBanEnded ? 'ban' : 'normal',
      });
    }
  }, [props.liveState.isEnded, liveResult]);

  /**
   * Get live time second
   */
  const getLiveTime = (): number => {
    if (props.liveState.liveData) {
      const now = new Date();
      const startTime = new Date(props.liveState.liveData.startDateTime);
      const time = Math.floor((now.getTime() - startTime.getTime()) / 1000);
      return time;
    } else if (liveResult) {
      return liveResult.streamTime;
    }
    return 0;
  };

  useEffect(() => {
    if (props.liveState.liveData === undefined) {
      return;
    }

    getLiveResult(props.liveState.liveData?.id)
      .unwrap()
      .then((liveResult) => {
        setLiveResult(liveResult);
        if (liveResult.reason === 'streaming-ban') {
          props.setBannedEnd(true);
        }
      });
  }, [props.liveState.liveData]);

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      centered
      scrollable={true}
      show={props.liveState.isEnded}
    >
      {props.liveState.isBanEnded && (
        <Modal.Header style={{ background: 'red', color: 'white' }}>
          不適切なコンテンツと判断されたため強制終了されました
        </Modal.Header>
      )}
      <Modal.Header>ライブ配信終了</Modal.Header>
      <Modal.Body>
        {liveResult ? (
          <div>
            <div className="live-result__txt-container">
              <p className="live-result__txt-left">ライブ配信時間</p>
              <p className="live-result__txt-right text-primary">
                {convertTime(getLiveTime())}
              </p>
            </div>

            <div className="live-result__txt-container">
              <p className="live-result__txt-left">累計視聴時間</p>
              <p className="live-result__txt-right text-primary">
                {convertTime(liveResult.totalJoindTime)}
              </p>
            </div>

            <div className="live-result__txt-container">
              <p className="live-result__txt-left">スコア</p>
              <p className="live-result__txt-right text-primary">
                {liveResult.score}
              </p>
            </div>

            <div className="live-result__txt-container">
              <p className="live-result__txt-left">いいね</p>
              <p className="live-result__txt-right text-primary">
                {liveResult?.niceCount}
              </p>
            </div>
          </div>
        ) : (
          <div
            style={{
              minHeight: '100px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <PuffLoader
              size={'42px'}
              color={'#d9534f'}
              cssOverride={{ alignSelf: 'center' }}
            ></PuffLoader>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ justifyContent: 'center' }}>
        <Button variant="primary" onClick={onClickEndLive}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
